/**
 * English catalogue for namespace 'audio' (W1-14). Pure data: the audio engine reports failures as MessageRefs
 * (`AudioEngineError.reason`, keys 'audio.<id>'); only the UI translates them.
 */

import type { MessageCatalog } from '../i18n/types';

export const AUDIO_MESSAGES = {
  unsupported: 'Audio playback is not available in this browser.',
  decodeFailed: 'This audio file could not be decoded. Convert it to MP3, OGG or WAV and try again.',
  calibrationCancelled: 'Latency calibration was cancelled.',
  calibrationNoTaps: 'Too few taps were detected. Tap once on every click and try again.',
  calibrationInconsistent:
    'Your taps did not follow the clicks steadily enough to measure the delay. Tap once on every click, keeping an even beat, and try again.',
  disposed: 'The audio engine was shut down.',
  superseded: 'A newer audio file replaced this one before it finished loading.',
} as const satisfies Readonly<Record<string, string>>;

export type AudioMessageId = keyof typeof AUDIO_MESSAGES;

const catalog: MessageCatalog = { ns: 'audio', locale: 'en', messages: AUDIO_MESSAGES };

export default catalog;
